import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PlaygroundTabs } from "@/app/playground/playground-tabs";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/playground"
)({
  loader: () => ({
    crumb: "Playground",
  }),
  component: PlaygroundLayout,
});

function PlaygroundLayout() {
  return (
    <div className="flex h-full flex-col gap-4">
      <PlaygroundTabs />
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
